import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { ComplexValue, ValueProperty } from 'ui';

export const connectedCasesRiskValues = (caseState, uiEngineProps) => ({
  connectedRiskArea: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskArea').valueItem,  
  connectedRiskWeight: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskWeight').value,
  connectedRiskAreaRest: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskAreaRest').valueItem,
  connectedRiskWeightRest: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskWeightRest').value  
});

export interface ConnectedCasesRiskValueShape {
  connectedRiskArea: ComplexValue<number>;  
  connectedRiskWeight: ValueProperty;
  connectedRiskAreaRest: ComplexValue<number>;
  connectedRiskWeightRest: ValueProperty;  
}
